/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_PasswordInputs */

const en_entity_password = /** @type {(inputs: Entity_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const de_entity_password = /** @type {(inputs: Entity_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Entity_PasswordInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_password = /** @type {((inputs?: Entity_PasswordInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_PasswordInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_password(inputs)
	return de_entity_password(inputs)
});